@if (filtersForm) {
<form class="filters-form tw-flex tw-flex-wrap tw-items-end tw-gap-x-8 md:tw-gap-x-4" [formGroup]="filtersForm">
  @for (filter of $any(settings.items); track filter.name) { @switch (filter.type) { @case (filterType.Search) {
  <mat-form-field class="{{ filter.name }} tw-flex">
    <mat-label>{{ filter.label | translate }}</mat-label>
    <input
      matInput
      formControlName="{{ filter.name }}"
      placeholder="{{ filter.placeholder | translate }}"
      [searchSlash]="filtersForm.get(filter.name).value"
    />
    <ui-svg-icon [name]="iconNames.Search" matSuffix></ui-svg-icon>
  </mat-form-field>
  } @case (filterType.CustomSearch) {
  <mat-form-field class="{{ filter.name }} tw-flex">
    <mat-label>{{ filter.label | translate }}</mat-label>
    <input
      matInput
      formControlName="{{ filter.name }}"
      placeholder="{{ filter.placeholder | translate }}"
      [searchSlash]="filtersForm.get(filter.name).value"
    />
    <ui-svg-icon [name]="filter.icon" matSuffix></ui-svg-icon>
  </mat-form-field>
  } @case (filterType.Select) {
  <mat-form-field class="{{ filter.name }} filter-select tw-flex">
    <mat-label>{{ filter.label | translate }}</mat-label>
    <mat-select formControlName="{{ filter.name }}" multiple="{{ filter.isMultiple }}">
      @for (option of filter.options; track option.value) {
      <mat-option [value]="option.value">
        {{ option.name | translate }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  } @case (filterType.ToggleGroup) {
  <div class="toggle-group tw-flex tw-flex-col">
    <mat-label class="{{ filter.name }} fixed-filter-label">{{ filter.label | translate }}</mat-label>
    <mat-button-toggle-group
      hideSingleSelectionIndicator
      [value]="filtersForm.get(filter.name).value"
      (change)="filtersForm.get(filter.name).setValue($event.value)"
    >
      @for (option of filter.options; track option.value) {
      <mat-button-toggle [value]="option.value">
        {{ option.name | translate }}
      </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
  } @case (filterType.SearchChips) {
  <mat-form-field class="{{ filter.name }} filter-chips tw-flex">
    <mat-label>{{ filter.label | translate }}</mat-label>
    <mat-chip-grid #inputChipList>
      @for (item of filtersForm.get(filter.name).value; track $index) {
      <mat-chip-row [removable]="true" (removed)="removeElement(filtersForm.get(filter.name), item)">
        {{ item }}
        <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
      </mat-chip-row>
      }
      <div class="tw-flex tw-grow tw-shrink-0 tw-basis-[100px] tw-items-center">
        <input
          #input
          [formControl]="chipsInputControl"
          [placeholder]="filter.placeholder | translate"
          [matChipInputFor]="inputChipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          [readonly]="false"
          (matChipInputTokenEnd)="addElement(filtersForm.get(filter.name), input, chipsInputControl)"
        />
        <ui-svg-icon [name]="filter.icon" matIconSuffix></ui-svg-icon>
      </div>
    </mat-chip-grid>
  </mat-form-field>
  } @case (filterType.DateTimeRange) {
  <ui-date-time-range
    class="filter-range"
    formControlName="{{ filter.name }}"
    [label]="filter.label | translate"
    [pickerType]="filter.pickerType"
    [initialValue]="filter.initialValue"
    [timezone]="timezone"
    #dateTimeRangeComponent
  >
    @if (isTimeRangeResetAvailable) {
    <ng-template #suffix>
      <div class="suffix">
        <ui-svg-icon
          [name]="iconNames.CalendarClock"
          (click)="dateTimeRangeComponent.datetimePicker.open()"
          class="pointer"
        ></ui-svg-icon>
        <ui-svg-icon
          [name]="iconNames.Close"
          (click)="dateTimeRangeComponent.resetDatepicker()"
          class="pointer tw-ml-2"
        ></ui-svg-icon>
      </div>
    </ng-template>
    }
  </ui-date-time-range>
  } } }
  <ng-content></ng-content>
</form>
}
